import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import actionPanelStyles from '../assets/jss/crm/components/actionPanelStyles';

import ActivityLoggingPanel from './ActivityLoggingPanel';
import NoteCreationPanel from './NoteCreationPanel';
import TextSendingPanel from './TextSendingPanel';

class ActionPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenActionTab: 0,
    };
  }

  createActionTab(label, i) {
    const { classes } = this.props;
    const tabClassNames = cx([
      classes.actionTab,
      classes.u_ellipsis,
      { [classes.selectedTab]: this.state.chosenActionTab === i },
    ]);
    const spanClassNames = classes.actionTabSpan;
    return (
      <div className={tabClassNames}>
        <span className={spanClassNames} onClick={() => this.setState({ chosenActionTab: i })}>
          {label}
        </span>
      </div>
    );
  }

  render() {
    const { classes, page, activityColumn, client, visibleFirmId, contacts, noteCreationFunc } = this.props;
    const { chosenActionTab } = this.state;
    return (
      <div className={classes.actionPanel + ' ' + classes.u_boxShadow}>
        <div className={classes.actionPanel_headerTabs}>
          {this.createActionTab('Log Activity', 0)}
          {this.createActionTab('Create Note', 1)}
          {this.createActionTab('Send Text', 2)}
        </div>
        {chosenActionTab === 0 && (
          <ActivityLoggingPanel
            page={page}
            activityColumn={activityColumn}
            client={client}
            referrerOrgId={visibleFirmId}
            contacts={contacts}
          />
        )}
        {chosenActionTab === 1 && <NoteCreationPanel noteCreationFunc={noteCreationFunc} />}
        {chosenActionTab === 2 && (
          <TextSendingPanel
            page={page}
            activityColumn={activityColumn}
            client={client}
            visibleFirmId={visibleFirmId}
            contacts={contacts}
          />
        )}
      </div>
    );
  }
}

export default withStyles(actionPanelStyles)(ActionPanel);
